import * as types from '@/store/workflow/actionTypes';
// eslint-disable-next-line import/no-cycle
import { loadWorkflows, createWorkflow, updateWorkflow } from '@/services/repository';
import {
  CLEAR_WORKFLOWS, SET_WORKFLOWS,
} from '@/store/workflow/mutationTypes';

export default {
  async [types.LOAD_WORKFLOWS]({ commit }) {
    try {
      const workflows = await loadWorkflows();
      commit(SET_WORKFLOWS, workflows);
    } catch (e) {
      console.error(e);
      commit(CLEAR_WORKFLOWS, []);
    }
  },
  async [types.UPDATE_WORKFLOWS]({ commit }, workflowPayload) {
    try {
      await updateWorkflow(workflowPayload);
    } catch (e) {
      console.error(e);
      commit(CLEAR_WORKFLOWS, []);
    }
  },
  async [types.ADD_WORKFLOW]({ dispatch, commit }, workflowPayload) {
    try {
      await createWorkflow(workflowPayload);
      dispatch(types.LOAD_WORKFLOWS);
    } catch (e) {
      console.error(e);
      commit(CLEAR_WORKFLOWS, []);
    }
  },
};
